import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=d12fc4ca&scoped=true"
import script from "./DownloadLink.vue?vue&type=script&lang=js"
export * from "./DownloadLink.vue?vue&type=script&lang=js"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=d12fc4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12fc4ca",
  null
  
)

export default component.exports